export var Name = 'request-favorites';
export var RequestFavorites = Name; // eslint-disable-next-line @typescript-eslint/no-empty-interface -- Used only to request state update across SPAs.